module.exports = __webpack_public_path__ + "img/xjzj.5e527ff0.jpg";